<template>
  <div class="row mb-4">
    <div class="col-md-12">
      <div class="newsdate pb-1">
        <i class="bi bi-megaphone mr-2"></i> {{ tempDate }}
      </div>
      <div class="newstitle bold pb-1">
        Mauris convallis odio in est consectetur
      </div>
      <div class="newscontent">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras pulvinar
        quam at efficitur tristique. Aliquam ut imperdiet urna. Nullam non
        cursus augue, nec congue arcu. Fusce ultrices eget diam vel tristique.
        Ut dui justo, ornare nec semper sed, bibendum vitae dui. Vestibulum at
        turpis at lectus mattis sagittis. Curabitur neque mauris, euismod sed
        sollicitudin pretium, cursus ac neque. Maecenas sit amet lorem interdum,
        venenatis est ut, placerat sapien. Nulla facilisi. Nam suscipit vel
        metus in faucibus. Pellentesque tortor lorem, dapibus vitae aliquam
        accumsan, molestie non nunc. Pellentesque id dolor augue. Donec sed
        tincidunt risus. Sed ligula metus, tincidunt a ex a, laoreet blandit
        quam. Vivamus lacinia enim vel ipsum scelerisque, ut hendrerit enim
        pretium. Vestibulum eget vestibulum ipsum, ac egestas turpis.
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import { formatDate } from "@/helpers/HelperTool";

@Component({})
class NewsItem extends Vue {
  @Prop({ default: null })
  News!: boolean;
  tempDate = "";

  mounted() {
    const today = new Date();
    this.tempDate = formatDate(today);
  }
}
export default NewsItem;
</script>
